module.exports = __webpack_public_path__ + "img/ic_move.f6987b80.svg";